import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk'
import * as y18n from '../y18n'


import globalMessage from './global-message'
import locales from './locales'
import enums from './enums'
import accounts from './accounts'
import products from './products'
import simcards from './simcards'
import subscriptions from './subscriptions'
import subscriptionsAdmin from './subscriptions-admin'
import users from './users'
import pageTexts from './page-texts'
import gdpr from './gdpr'
import page from './page'
import email from './email'
import app from './app'
import admin from './admin'
import subscriptionPacks from './subscription-packs'

const rootReducer = {
  globalMessage,
  locales,
  enums,
  accounts,
  products,
  simcards,
  subscriptions,
  subscriptionsAdmin,
  users,
  pageTexts,
  gdpr,
  page,
  email,
  app,
  admin,
  subscriptionPacks
}

const reduxDevToolsOptions = {
  trace: true,
  traceLimit: 25
}

const composeEnhancers = composeWithDevTools(reduxDevToolsOptions);
const store = createStore(combineReducers(rootReducer), composeEnhancers(applyMiddleware(thunkMiddleware)))
y18n.setStore(store)
export default store



// WEBPACK FOOTER //
// ./src/store/index.js